import React from 'react';
import PropTypes from 'prop-types';
import type {AutocompleteProps, AutocompleteRenderInputParams} from '@material-ui/lab';
import {Autocomplete} from '@material-ui/lab';
import {CatalogValueShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {EfeFieldText} from 'components';

/**
 * Customization for Autocomplete
 * @param {InferPropTypes<any>} props
 * @returns {JSX.Element}
 * @constructor
 */

function EfeAutocomplete(
    props: InferPropTypes<
        typeof EfeAutocomplete.propTypes &
            AutocompleteProps<string, undefined, undefined, undefined>
    >
) {
    const {options, labelText, placeholder, onValueChange, selectedValue, ...other} = props;
    const [inputValue, setInputValue] = React.useState<string | null>(null);

    const renderInput = (params: AutocompleteRenderInputParams) => (
        <EfeFieldText
            {...params}
            placeholder={placeholder}
            label={labelText}
            InputLabelProps={{shrink: true}}
            autoComplete='off'
        />
    );

    function getLabel(input: any): string | null {
        let value: any;
        if (input && input.id) {
            value = input.id;
        } else {
            value = input;
        }
        const items: Array<any> = options.filter((item: any) => item.id === value);
        if (items && items.length > 0) {
            return items[0].value;
        } else {
            return null;
        }
    }

    function getId(tag: string): any {
        const items: Array<any> = options.filter((item: any) => item.value === tag);
        if (items && items.length) {
            return items[0].id;
        } else {
            return null;
        }
    }

    const onTagsChange = (event: any, values: any) => {
        onValueChange(getId(values));
    };

    React.useEffect(() => {
        setInputValue(getLabel(selectedValue));
    }, [selectedValue]);

    return (
        <Autocomplete
            freeSolo
            value={inputValue}
            renderInput={renderInput}
            options={options.map((option) => option?.value)}
            onChange={onTagsChange}
            {...other}
        />
    );
}

EfeAutocomplete.propTypes = {
    /** Array of OptionType`s, for autocomplete values */
    options: PropTypes.arrayOf(CatalogValueShape).isRequired,
    /** Label Text for Input */
    labelText: PropTypes.string,
    selectedValue: PropTypes.any,
    onValueChange: PropTypes.func.isRequired,
    /** Is Required field */
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
};

EfeAutocomplete.defaultProps = {
    options: [],
    placeholder: 'Selecciona',
    required: false,
};
export default EfeAutocomplete;
